import type { FC } from "react";
import { AdminDashboardPage } from "routes/admin/AdminDashboardPage/AdminDashboardPage";

const AdminDashboardPageContainer: FC = () => {
  return <AdminDashboardPage />;
};

export default AdminDashboardPageContainer;
